module.exports = __webpack_public_path__ + "img/img_page_06_02.136547da.png";